import { Directive, Input, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[numberInput]'
})
export class NumberInputDirective {
  @Input() int: boolean = true;
  @Input() positive: boolean = false;
  @Input() money: boolean = false;

  lastValue: string;
  pattern: RegExp;

  constructor(@Self() private ngControl: NgControl) {
    this.ngControl.valueChanges.subscribe((value: string) => {
      if(value == null || value.match(this.pattern) != null)
        this.lastValue = value;
      else
        this.ngControl.control.setValue(this.lastValue);
    });
  }

  ngOnInit() {
    if(this.money)
      this.pattern = this.positive ? /^\d*\.?\d?\d?$/g : /^-?\d*\.?\d?\d?$/g;
    else if(this.int)
      this.pattern = this.positive ? /^\d*$/g : /^-?\d*$/g;
    else
      this.pattern = this.positive ? /^\d*\.?\d*$/g : /^-?\d*\.?\d*$/g;
  }
}